import { useLazyQuery } from "@apollo/client/react";
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { SelectInput } from '../../../../components/selectInput/SelectInput';
import { SwitchInput } from '../../../../components/switchInput/SwitchInput';
import { TextInput } from '../../../../components/textInput/TextInput';
import { DropdownContent } from '../../../../components/dropdownContent/DropdownContent';

import { adaptComplejidadArray } from '../../../../adapters/complejidadAdapter';
import { adaptFranjaEtariaArray } from '../../../../adapters/franjaEtariaAdapter';
import { adaptReporteVentaArray } from '../../../../adapters/reporteVentaAdapter';
import { adaptTipoPlanArray } from '../../../../adapters/tipoPlanAdapter';
import { adaptTipoServicioArray } from '../../../../adapters/tipoServicioAdapter';
import { adaptUbicacionArray } from '../../../../adapters/ubicacionAdapter';
import { adaptTipoModuloArray } from '../../../../adapters/tipoModuloAdapter';
import { adaptModoInfusionArray } from '../../../../adapters/modoInfusionAdapter';

import { GET_ALL_COMPLEJIDAD } from '../../../../data/graphQL/queries/PlanCuidado/getComplejidad';
import { GET_ALL_FRANJA_ETARIA } from '../../../../data/graphQL/queries/PlanCuidado/getFranjaEtaria';
import { GET_DATA_TIPO_MODULO } from '../../../../data/graphQL/queries/PlanCuidado/getDataTipoModulo';
import { GET_ALL_TIPO_PLAN } from '../../../../data/graphQL/queries/PlanCuidado/getTipoPlan';
import { GET_ALL_TIPO_SERVICIO } from '../../../../data/graphQL/queries/PlanCuidado/getTipoServicio';
import { GET_ALL_UBICACION } from '../../../../data/graphQL/queries/PlanCuidado/getUbicacion';
import { GET_ALL_MODO_INFUSION } from '../../../../data/graphQL/queries/PlanCuidado/getAllModoInfusion';
import { GET_TIPO_MODULO } from '../../../../data/graphQL/queries/TipoModulo/queries';

import './stepDatosGenerales.scss';
import { GET_ALL_REPORTE_VENTA } from '../../../../data/graphQL/queries/PlanCuidado/getReporteVenta';

const StepDatosGenerales = ({ stepsData, setStepsData }) => {
  const initialDatosGenerales = {
    idPlanCuidado: '',
    profesionales: false,
    envios: false,
    tm: false,
    idUbicacionPlan: 0,
    idComplejidad: 0,
    idFranjaEtaria: 0,
    idReporteVenta: 0,
    idTipoServicio: 0,
    cotizado: false,
    esquema: false,
    idTipoPlan: 0,
    topeCalAdulto: '',
    topeCalPediatrico: '',
    codigoSap: '',
    nombre: '',
    activo: false,
    complejidad: false,
    observacion: '',
    idTipoModulo: '',
    volumenInicial: '',
    volumenFinal: '',
    idModoInfusion: 0
  };

  const ESTADO_PLAN_INCOMPLETO = 2;

  const [getModoInfusion, { loading: modoInfusionLoading, data: modoInfusionData }] = useLazyQuery(GET_ALL_MODO_INFUSION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!modoInfusionData) return;
    setModoInfusion(adaptModoInfusionArray(modoInfusionData));
  }, [modoInfusionData])

  const [getTipoServicios, { loading: tipoServiciosLoading, data: tipoServicioData }] = useLazyQuery(GET_ALL_TIPO_SERVICIO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!tipoServicioData) return;
    setTipoServicios(adaptTipoServicioArray(tipoServicioData));
  }, [tipoServicioData])

  const [getUbicaciones, { loading: ubicacionesLoading, data: ubicacionData }] = useLazyQuery(GET_ALL_UBICACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!ubicacionData) return;
    setUbicaciones(adaptUbicacionArray(ubicacionData));
  }, [ubicacionData])

  const [getFranjasEtaria, { loading: franjasEtariaLoading, data: franjaEtariaData }] = useLazyQuery(GET_ALL_FRANJA_ETARIA, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!franjaEtariaData) return;
    setFranjasEtaria(adaptFranjaEtariaArray(franjaEtariaData));
  }, [franjaEtariaData])

  const [getComplejidades, { loading: complejidadesLoading, data: complejidadData }] = useLazyQuery(GET_ALL_COMPLEJIDAD, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!complejidadData) return;
    setComplejidades(adaptComplejidadArray(complejidadData));
  }, [complejidadData])

  const [getReporteVentas, { loading: reporteVentasLoading, data: reporteVentaData }] = useLazyQuery(GET_ALL_REPORTE_VENTA, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!reporteVentaData) return;
    const adaptedReportes = reporteVentaData.allReporteVenta.map(reporte => ({
      id: reporte.idReporteVenta,
      displayName: reporte.descripcion,
      name: reporte.descripcion,
    })); 
    setReporteVentas(adaptedReportes);
  }, [reporteVentaData])

  const [getTipoPlanes, { loading: tipoPlanesLoading, data: tipoPlanData }] = useLazyQuery(GET_ALL_TIPO_PLAN, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoPlanData) return;
    setTipoPlanes(adaptTipoPlanArray(tipoPlanData));
  }, [tipoPlanData])


  const [getTipoModulos, { loading: tipoModulosLoading, data: dataTipoModulo }] = useLazyQuery(GET_TIPO_MODULO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!dataTipoModulo) return;
    setTipoModulos(adaptTipoModuloArray(dataTipoModulo));
  }, [dataTipoModulo])

  const [getDataTipoModulo, { loading: dataTipoModuloLoading, data: tipoModuloData }] = useLazyQuery(GET_DATA_TIPO_MODULO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!tipoModuloData) return;
    setStepsData(previousData => ({
      ...previousData,
      datosGenerales: {
        ...previousData.datosGenerales,
        complejidad: (tipoModuloData.dataTipoModulo.valorEsperado.complejidad == 1),
        idReporteVenta: tipoModuloData.dataTipoModulo.valorEsperado.idTipoModuloReporta
      }
    }));
  }, [tipoModuloData])

  const [modoInfusion, setModoInfusion] = useState([]);
  const [tipoServicios, setTipoServicios] = useState([]);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [franjasEtaria, setFranjasEtaria] = useState([]);
  const [complejidades, setComplejidades] = useState([]);
  const [reporteVentas, setReporteVentas] = useState([]);
  const [tipoPlanes, setTipoPlanes] = useState([]);
  const [tipoModulos, setTipoModulos] = useState([]);

  useEffect(() => {
    if (!tipoServiciosLoading) {
      getTipoServicios();
    }

    if (!ubicacionesLoading) {
      getUbicaciones();
    }

    if (!franjasEtariaLoading) {
      getFranjasEtaria();
    }

    if (!complejidadesLoading) {
      getComplejidades();
    }

    if (!reporteVentasLoading) {
      getReporteVentas();
    }

    if (!tipoPlanesLoading) {
      getTipoPlanes();
    }

    if (!tipoModulosLoading) {
      getTipoModulos();
    }

    if (!modoInfusionLoading) {
      getModoInfusion({ variables: { campo: 'Modo de infusión Plan Cuidado' } });
    }

  }, []);

  useEffect(() => {
    if (stepsData?.datosGenerales?.idTipoModulo > 0)
      setReporteVentaYComplejidad(stepsData?.datosGenerales?.idTipoModulo);
  }, [stepsData?.datosGenerales?.idTipoModulo]);


  const handleChange = (e) => {
    const { value, name } = e.target;
    setStepsData((previousData) => ({
      ...previousData,
      datosGenerales: {
        ...previousData.datosGenerales,
        [name]: value
      }
    }));
  };

  const handleChangeTipoModulo = (e) => {
    const { value, name } = e.target;
    // si NO es AP, SIP o NPID
    if (value !== 2 && value !== 10 && value !== 14) {
      setStepsData((previousData) => ({
        ...previousData,
        datosGenerales: {
          ...previousData.datosGenerales,
          [name]: value,
          volumenInicial: '',
          volumenFinal: '',
          idModoInfusion: null
        }
      }));
    } else {
      setStepsData((previousData) => ({
        ...previousData,
        datosGenerales: {
          ...previousData.datosGenerales,
          [name]: value
        }
      }));
    }

    setReporteVentaYComplejidad(value);
  };

  const setReporteVentaYComplejidad = (idTipoModulo) => {
    getDataTipoModulo({ variables: { idTipoModulo: idTipoModulo } });
  };

  const handleToggle = (e) => {
    const { checked, name } = e.target;
    setStepsData((previousData) => ({
      ...previousData,
      datosGenerales: {
        ...previousData.datosGenerales,
        [name]: checked
      }
    }));
  };

  return (
    <div className='plan-cuidado-step-datosGenerales'>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        gap={1}
        className='plan-cuidado-step-datosGenerales grid-row'>

        <Grid size={{ xs: 2.3 }}>
          <TextInput
            onChange={handleChange}
            label='Identificador'
            placeholder='Ingrese Identificador'
            name='idPlanCuidado'
            value={stepsData?.datosGenerales?.idPlanCuidado}
            disabled={true} />

        </Grid>
        <Grid size={{ xs: 2.3 }}>
          <TextInput
            onChange={handleChange}
            label='Código Sap'
            placeholder='Ingrese Codigo Sap'
            name='codigoSap'
            maxLength={18}
            value={stepsData?.datosGenerales?.codigoSap}
            disabled={stepsData?.datosGenerales?.idPlanCuidadoEstado != ESTADO_PLAN_INCOMPLETO} />

        </Grid>
        <Grid size={{ xs: 2.3 }}>
          <TextInput
            onChange={handleChange}
            label='Nombre'
            placeholder='Ingrese un nombre'
            name='nombre'
            value={stepsData?.datosGenerales?.nombre} />

        </Grid>
        <Grid size={{ xs: 0.8 }}>
          <div className='switch-row'>
            <span className='span-row'>Activo</span>
            <SwitchInput
              onChange={handleToggle}
              name='activo'
              checked={stepsData?.datosGenerales?.activo}
              className='switch-row container' />

          </div>
        </Grid>
      </Grid>
      <DropdownContent sectionTitle={'Programa'} className='grid-row'>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 12
          }}
          className='plan-cuidado-step-datosGenerales grid-row'>

          <Grid size={{ xs: 7.1 }}>
            <SelectInput
              options={tipoModulos}
              label='Tipo'
              onChange={handleChangeTipoModulo}
              value={stepsData?.datosGenerales?.idTipoModulo}
              name='idTipoModulo'
              disabled={stepsData?.datosGenerales?.idPlanCuidadoEstado != ESTADO_PLAN_INCOMPLETO} />

          </Grid>
          <Grid className='switch-flex-end' size={{ xs: 1.7 }}>
            <div className='switch-row'>
              <span className='span-row'>Profesionales</span>
              <SwitchInput
                onChange={handleToggle}
                name='profesionales'
                checked={stepsData?.datosGenerales?.profesionales} />

            </div>
          </Grid>
          <Grid className='switch-flex-end' size={{ xs: 1 }}>
            <div className='switch-row'>
              <span className='span-row'>TM</span>
              <SwitchInput
                onChange={handleToggle}
                name='tm'
                checked={stepsData?.datosGenerales?.tm} />

            </div>
          </Grid>
          <Grid className='switch-flex-end' size={{ xs: 1.2 }}>
            <div className='switch-row'>
              <span className='span-row'>Envios</span>
              <SwitchInput
                onChange={handleToggle}
                name='envios'
                checked={stepsData?.datosGenerales?.envios} />

            </div>
          </Grid>
        </Grid>
      </DropdownContent>
      {/* si es AP, SIP o NPID */}
      {(stepsData?.datosGenerales?.idTipoModulo === 2 ||
        stepsData?.datosGenerales?.idTipoModulo === 10 ||
        stepsData?.datosGenerales?.idTipoModulo === 14) &&
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          gap={1}
          className='plan-cuidado-step-datosGenerales grid-row'>

          <Grid size={{ xs: 2.7 }}>
            <TextInput
              type="number"
              onChange={handleChange}
              label='Volumen Inicial'
              placeholder='Ingrese volumen'
              name='volumenInicial'
              value={stepsData?.datosGenerales?.volumenInicial} />

          </Grid>
          <Grid size={{ xs: 2.7 }}>
            <TextInput
              type="number"
              onChange={handleChange}
              label='Volumen Final'
              placeholder='Ingrese volumen'
              name='volumenFinal'
              value={stepsData?.datosGenerales?.volumenFinal} />

          </Grid>
          <Grid size={{ xs: 2.4 }}>
            <SelectInput options={modoInfusion}
              label='Modo de infusion'
              placeHolder='Elige un modo de infusion'
              onChange={handleChange}
              value={stepsData?.datosGenerales?.idModoInfusion}
              name='idModoInfusion' />

          </Grid>
        </Grid>
      }
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        gap={1}
        className='plan-cuidado-step-datosGenerales grid-row'>

        <Grid size={{ xs: 3.8 }}>
          <SelectInput options={tipoServicios}
            label='Tipo de Servicio'
            placeHolder='Elige un tipo de servicio'
            onChange={handleChange}
            value={stepsData?.datosGenerales?.idTipoServicio}
            name='idTipoServicio' />

        </Grid>
        <Grid className='switch-flex-end' size={{ xs: 1.3 }}>
          <div className='switch-row'>
            <span className='span-row'>Cotizado</span>
            <SwitchInput
              onChange={handleToggle}
              name='cotizado'
              checked={stepsData?.datosGenerales?.cotizado} />

          </div>
        </Grid>
        <Grid className='switch-flex-end' size={{ xs: 1.3 }}>
          <div className='switch-row'>
            <span className='span-row'>Posee Esquema</span>
            <SwitchInput
              onChange={handleToggle}
              name='esquema'
              checked={stepsData?.datosGenerales?.esquema} />

          </div>
        </Grid>
        <Grid className='switch-flex-end' size={{ xs: 1.2 }}>
          <div className='switch-row'>
            <span className='span-row'>Complejidad CO</span>
            <SwitchInput
              onChange={handleToggle}
              name='complejidad'
              checked={stepsData?.datosGenerales?.complejidad}
              disabled={true} />

          </div>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        gap={1}
        className='plan-cuidado-step-datosGenerales grid-row'>

        <Grid size={{ xs: 1.6 }}>
          <SelectInput options={ubicaciones}
            label='Ubicacion Plan'
            placeHolder='Elige una ubicacion'
            onChange={handleChange}
            value={stepsData?.datosGenerales?.idUbicacionPlan}
            name='idUbicacionPlan' />

        </Grid>
        <Grid size={{ xs: 1 }}>
          <SelectInput options={franjasEtaria}
            label='Franja Etaria'
            placeHolder='Elige una ubicacion'
            onChange={handleChange}
            value={stepsData?.datosGenerales?.idFranjaEtaria}
            name='idFranjaEtaria' />

        </Grid>
        <Grid size={{ xs: 1 }}>
          <SelectInput options={complejidades}
            label='Complejidad'
            placeHolder='Elige una complejidad'
            onChange={handleChange}
            value={stepsData?.datosGenerales?.idComplejidad}
            name='idComplejidad' />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <SelectInput options={reporteVentas.map(reporte => ({
              id: reporte.id,
              displayName: tipoModulos.find(tipo => tipo.abreviacion === reporte.displayName)?.displayName,
              name: reporte.name,
            }))}
            label='Reporte Ventas'
            onChange={handleChange}
            value={stepsData?.datosGenerales?.idReporteVenta}
            name='idReporteVenta'
            disabled={true} />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <SelectInput options={tipoPlanes}
            label='Tipo de Plan'
            placeHolder='Elige un tipo de plan'
            onChange={handleChange}
            value={stepsData?.datosGenerales?.idTipoPlan}
            name='idTipoPlan' />

        </Grid>
      </Grid>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        gap={1}
        className='plan-cuidado-step-datosGenerales grid-row'>

        <Grid size={{ xs: 3.8 }}>
          <TextInput
            type="number"
            onChange={handleChange}
            label='Tope Calorias Pediatrico'
            placeholder='Ingrese calorias'
            name='topeCalPediatrico'
            value={stepsData?.datosGenerales?.topeCalPediatrico} />

        </Grid>
        <Grid size={{ xs: 4.1 }}>
          <TextInput
            type="number"
            onChange={handleChange}
            label='Tope Calorias Adulto'
            placeholder='Ingrese calorias'
            name='topeCalAdulto'
            value={stepsData?.datosGenerales?.topeCalAdulto} />

        </Grid>
      </Grid>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}>

        <Grid size={{ xs: 12 }}>
          <TextInput
            onChange={handleChange}
            label='Observaciones'
            placeholder='Ingrese Observaciones'
            name='observacion'
            value={stepsData?.datosGenerales?.observacion}
            multiline={true}
            rows={4} />

        </Grid>
      </Grid>
    </div>);

};

export default StepDatosGenerales;